import React from 'react'
import PropTypes from 'prop-types'

import { Heading, Square } from 'Components/Blocks/_Legacy'
import { Row, Wrapper } from 'Components/UI'
import { Icon, Motion, Text } from 'Components/UI/_Legacy'

import {
  iconHealthGlyph,
  iconMedalGlyph,
  iconMoney3Glyph,
  iconPiggyBankGlyph,
  iconPresentationChartGlyph,
  iconStatusUpGlyph,
  iconTrendDownGlyph,
} from 'Assets/_Legacy/CtoPage'

import {
  Card,
  CardContainer,
  Container,
  Content,
  SquaresHolder,
} from './styles'

const CARD_ICONS = [
  iconPiggyBankGlyph,
  iconPresentationChartGlyph,
  iconMoney3Glyph,
  iconStatusUpGlyph,
  iconTrendDownGlyph,
  iconHealthGlyph,
]

function Benefits({ data }) {
  return (
    <Container>
      <SquaresHolder>
        <Square
          angle={15}
          horizontalAlign={['unset', -490]}
          size={600}
          verticalAlign={[500, 0]}
        />

        <Square
          angle={-30}
          horizontalAlign={[-530, null]}
          size={600}
          verticalAlign={[null, -300]}
        />
      </SquaresHolder>

      <Wrapper wayPointTop>
        <Motion>
          <Content>
            {/* `as` was a dead prop on Heading (dropped by pick()) — the
                title renders as the default h2; the page h1 is the Hero. */}
            <Heading
              fontSizes={{ title: [24, 24, 45], sub: [14, 14, 16] }}
              horizontalAlign={[
                'center',
                'center',
                'center',
                'center',
                'center',
                'left',
              ]}
              tagGlyph={iconMedalGlyph}
              tagText={data?.benefitsTagText}
              tagTextAs="h4"
              titleText={{
                first: { text: data?.benefitsTitleBold, bold: true },
                second: { text: data?.benefitsTitleRegular, bold: false },
              }}
            />

            <CardContainer
              ml={[0, 0, 0, 0, 0, 7, 12]}
              mt={[17, 17, 17, 17, 17, 0]}
            >
              {data?.benefitsCard.map((card, index) => (
                <Card key={card.id}>
                  <Row center mb={5}>
                    <Icon glyph={CARD_ICONS[index]} size={36} />

                    <Text as="h3" bold fontSize={20} ml={5}>
                      {card.cardTitle}
                    </Text>
                  </Row>

                  <Text fontSize={16} light>
                    {card.cardText}
                  </Text>
                </Card>
              ))}
            </CardContainer>
          </Content>
        </Motion>
      </Wrapper>
    </Container>
  )
}

Benefits.defaultProps = {
  data: {},
}

Benefits.propTypes = {
  data: PropTypes.object,
}

export default Benefits
